import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import {WeaTools, WeaErrorPage, WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const { ls } = WeaTools;
import EHeader from '../common/EHeader';
import FooterMore from "../common/FooterMore";
import { NoRightCom } from '../../util/common';
import './style.css';
//元素组件
class DocContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edata: null,
            refresh: false,
            eContentisShowX:"0",
            width: 0,
        }
        this.handleEData = this.handleEData.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }
    handleDelete(){
        this.setState({
            edata: null,
        });
        ls.set('edata-'+this.props.config.params.eid, null);
    }
    handleRefresh(){
        this.setState({
            refresh: true,
        });
        this.handleEData(this.props.config.params);
    }
    handleEData(params){
        const { eid, api } = params;
        const loadContent = () => {
            let width = $("#content_view_id_"+eid).width() || 0;
            this.setState({
                edata: ls.getJSONObj('edata-'+eid),
                width,
            });
            WeaTools.callApi(api || '/api/portal/element/doccontent', 'POST', {...params}).then(result=> {
                ls.set('edata-'+eid, result.data);
                this.setState({
                    edata: result.data,
                    eContentisShowX:result.eContentisShowX,
                    refresh: false,
                });
            });
        }
        if($("#content_view_id_"+eid)[0]){
            loadContent();
        }else{
            let timer = setTimeout(()=>{
                loadContent();
                clearTimeout(timer);
            },100);
        }
    }
    componentDidMount(){
        this.handleEData(this.props.config.params);
    }
    componentWillReceiveProps(nextProps){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = { 
            item: nextProps.config.item, 
            params: nextProps.config.params, 
            isHasRight: nextProps.config.isHasRight,
        };
        if(!isEqual(config, _config) || nextProps.config.isRender){
            this.handleEData(nextProps.config.params);
        }
    }
    componentDidUpdate(){
        const { item } = this.props.config;
        let width = $("#content_view_id_"+item.eid).width() || 0;
        this.setState({width});
    }
    shouldComponentUpdate(nextProps, nextState){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = {
            item: nextProps.config.item, 
            params: nextProps.config.params, 
            isHasRight: nextProps.config.isHasRight,
        };
        return !isEqual(this.state, nextState) || !isEqual(config, _config)
    }
    render() {
        const { edata, refresh, width ,eContentisShowX} = this.state;
        const { config, fontSizeMp } = this.props;
        let _eContentisShowX = 'hidden';
        if(eContentisShowX==='1'){
            _eContentisShowX = 'auto';
        }
        if(!config || !edata) return <div/>;
        const { isHasRight, item } = config;
        const { eid, ebaseid, content, header, contentview, style } = item;
        const { style: style1= {} } = contentview;
        let EContentHtml = <div/>;
        if(isHasRight){
            if(!isEmpty(edata)) EContentHtml = <div className="portal-element-doc-content" style={{width:'auto',whiteSpace: 'nowrap'}} id={`__content__${eid}`} dangerouslySetInnerHTML={{ __html: edata.data }}></div>;
        }else{
            EContentHtml = <NoRightCom ecId={`${this && this.props && this.props.ecId || ''}_NoRightCom@pihm49`}/>
        }
        return <div className="item"
                    style={style}
                    id={`item_${eid}`} 
                    data-eid={eid} data-ebaseid={ebaseid} 
                    data-needRefresh={item.needRefresh} 
                    data-cornerTop={item.cornerTop} 
                    data-cornerTopRadian={item.cornerTopRadian}
                    data-cornerBottom={item.cornerBottom} 
                    data-cornerBottomRadian={item.cornerBottomRadian}>
                    <EHeader ecId={`${this && this.props && this.props.ecId || ''}_EHeader@dki63d`} config={config} handleRefresh={this.handleRefresh} handleDelete={this.handleDelete} fontSizeMp={fontSizeMp}/>
                    <div className="setting" id={`setting_${eid}`}></div>
                    <div className="content" id={`content_${eid}`} style={{width:'auto',_width:'100%'}}>
                        <div className="content_view" id={`content_view_id_${eid}`} style={{height: style1.height,overflowX:_eContentisShowX}}>
                            <Spin ecId={`${this && this.props && this.props.ecId || ''}_Spin@tyr2ga`} spinning={refresh}>{EContentHtml}</Spin>
                        </div>
                        <div style = {{textAlign:'right'}} id={`footer_${eid}`}><FooterMore ecId={`${this && this.props && this.props.ecId || ''}_FooterMore@7v85ck`} config={this.props.config}/></div>
                    </div>
            </div>;
    }
}

class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
            return ( <WeaErrorPage ecId={`${this && this.props && this.props.ecId || ''}_WeaErrorPage@l7vnpv`} msg = { hasErrorMsg ? this.props.error : getLabel(388017,"对不起，元素加载异常，请联系管理员！") }/>
        );
    }
}
DocContent = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(DocContent);
export default DocContent;






// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/doccontent/index.js